import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSetup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.25 3.75H0.75V15.75C0.75 16.575 1.425 17.25 2.25 17.25H14.25V15.75H2.25V3.75ZM15.75 0.75H5.25C4.425 0.75 3.75 1.425 3.75 2.25V12.75C3.75 13.575 4.425 14.25 5.25 14.25H15.75C16.575 14.25 17.25 13.575 17.25 12.75V2.25C17.25 1.425 16.575 0.75 15.75 0.75ZM15.75 12.75H5.25V2.25H15.75V12.75Z",
		fill: "#5A7481"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 5.25,
		y: 2.25,
		width: 10.5,
		height: 10.5,
		fill: "#5A7481"
	})]
});
export default SvgSetup;
